import ModalComp from "./components/modal";

function App() {
  return (
    <div className="App">
      <ModalComp />
    </div>
  );
}

export default App;
